import type { LiveOperations } from '../types/liveOperations'
import { fetchApi } from './api'

/**
 * Live Operations — what the worker has recorded as running right now.
 *
 * Replaces the fixture `getLiveOperations` in `observatoryApi.ts`, which
 * returned five invented runs with ticking timers and a percent complete the
 * server has no way to measure. Its own module, as `dataCombApi.ts` and
 * `etlJobsApi.ts` are, so the fixture can be deleted without touching this.
 */
export function getLiveOperations(): Promise<LiveOperations> {
  return fetchApi<LiveOperations>('/api/observatory/operations/live')
}
